var levelOfAWSUsage = {
	"Level of AWS usage": "AWS Kullanım Düzeyi",
	"Do not use AWS today": "Şu anda AWS'yi kullanmıyorum",
	"Evaluating/experimenting with AWS": "AWS ile değerlendirmeler/denemeler yapıyorum",
	"Run dev/test workloads on AWS": "AWS'de geliştirme/test iş yükleri çalıştırıyorum",
	"Run a production workload on AWS": "AWS'de tek bir üretim iş yükü çalıştırıyorum",
	"Run multiple production workloads on AWS": "AWS'de birden fazla üretim iş yükü çalıştırıyorum"
};

export { levelOfAWSUsage as default };
